
import AgricultureIcon from '@mui/icons-material/Agriculture';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import SchoolIcon from '@mui/icons-material/School';
import CameraFrontIcon from '@mui/icons-material/CameraFront';
import CasesIcon from '@mui/icons-material/Cases';
import PhotoCameraFrontIcon from '@mui/icons-material/PhotoCameraFront';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import InfoIcon from '@mui/icons-material/Info';
// import Map from '@mui/icons-material/Map';
// import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
// import BluetoothAudioIcon from '@mui/icons-material/BluetoothAudio';
import Key from '@mui/icons-material/Key';
// import agriculture from '@mui/icons-material/Agriculture';


const userAgent = navigator.userAgent.toLowerCase();

// Define the isMobileDevice function
function isMobileDevice(userAgent) {
  return /android|iphone|mobile|blackberry|iemobile/.test(userAgent);
}

// Helper function to filter menu items
const filterMenuItems = (menuItems) => {
  console.log('userAgent: ', isMobileDevice(userAgent));

  return menuItems;
};



const rawMenuItems  = [
  {
    heading: 'General',
    items: [
         {
        name: 'Dashboards',
        icon: DashboardIcon,
        link: '',
        items: [
          {
            name: 'MyItarra Overview',
            link: '/extended-sidebar/dashboards',
            badge: ``,
            badgeTooltip: `Overview of the system`
          },
        ]
      },
      {
        name: 'MyItarra',
        icon: ControlCameraIcon,
        link: '/extended-sidebar/myitarra',
        items: [
          // {
          //   name: 'Local Access',
          //   link: 'myitarra/localaccess',
          //   badge: '',
          //   badgeTooltip: 'Local Access via Bluetooth',
          //   icon: BluetoothAudioIcon,
          // },
          // {
          //   name: 'Remote Access',
          //   link: 'myitarra/remoteaccess',
          //   badge: '',
          //   icon: SettingsRemoteIcon,
          // },
          {
            name: 'My Keys',
            link: 'myitarra/mykeys',
            badge: '',
            icon: Key,
          },
          {
            name: 'My Fleet',
            link: 'myitarra/myfleet',
            badge: '',
            icon: AgricultureIcon,
          },
          // {
          //   name: 'My Maps',
          //   link: 'myitarra/mymaps',
          //   badge: '',
          //   icon: Map,
          // },
        ]
      },
      {
        name: 'MyDemos',
        icon: SchoolIcon,
        link: '/extended-sidebar/myitarra',
        items: [
          // {
          //   name: 'Local Access',
          //   link: 'myitarra/localaccess',
          //   badge: '',
          //   badgeTooltip: 'Local Access via Bluetooth',
          //   icon: BluetoothAudioIcon,
          // },
          // {
          //   name: 'Remote Access',
          //   link: 'myitarra/remoteaccess',
          //   badge: '',
          //   icon: SettingsRemoteIcon,
          // },
          {
            name: 'Customer Info',
            link: 'demo/just_info',
            badge: '',
            icon: InfoIcon,
          },
          {
            name: 'Tractor Demo',
            link: 'demo/tractor',
            badge: '',
            icon: AgricultureIcon,
          },
          {
            name: 'Selfie Demo',
            link: 'demo/selfie',
            badge: '',
            icon: CameraFrontIcon,
          },
          {
            name: 'Selfie Camera',
            link: 'selfie_camera',
            badge: '',
            icon: PhotoCameraFrontIcon,
          },

          // {
          //   name: 'My Maps',
          //   link: 'myitarra/mymaps',
          //   badge: '',
          //   icon: Map,
          // },
        ]
      },
      {
        name: 'My Details',
        icon: AccountCircleIcon,
        link: '/extended-sidebar/myitarra',
        items: [
          // {
          //   name: 'Local Access',
          //   link: 'myitarra/localaccess',
          //   badge: '',
          //   badgeTooltip: 'Local Access via Bluetooth',
          //   icon: BluetoothAudioIcon,
          // },
          // {
          //   name: 'Remote Access',
          //   link: 'myitarra/remoteaccess',
          //   badge: '',
          //   icon: SettingsRemoteIcon,
          // },
          {
            name: 'My V Card',
            link: 'vcard',
            badge: '',
            icon: CasesIcon,
          },
     

          // {
          //   name: 'My Maps',
          //   link: 'myitarra/mymaps',
          //   badge: '',
          //   icon: Map,
          // },
        ]
      },
    ]
  },
];


// const rawMenuItemsMobile  = [
//   {
//     heading: 'General',
//     items: [
//          {
//         name: 'Dashboards',
//         icon: DashboardIcon,
//         link: '',
//         items: [
//           {
//             name: 'MyItarra Overview',
//             link: '/extended-sidebar/dashboards',
//             badge: ``,
//             badgeTooltip: `Overview of the system`
//           },
//         ]
//       },
//       {
      
//             name: 'Mobile Access',
//             icon: AgricultureIcon,
//             link: '/mobile/portrate'
        
//       },
//     ]
//   },
// ];


const menuItems = filterMenuItems(rawMenuItems);

export default menuItems;
